import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { EntityRecordsTable, KeyValueTable } from "../../shared";

const ReportSectionBlock = ({
    t,
    section,
    breakBefore = false,
}) => {
    if (!section) {
        return null;
    }

    const {
        title,
        type = "keyValue",
        rows = [],
        columns = [],
        records = [],
        titleColumnLabel,
        detailsColumnLabel,
    } = section;

    const hasContent = type === "records"
        ? records.length > 0
        : rows.length > 0;

    if (!hasContent) {
        return null;
    }

    const sectionTitle = (
        <Text style={styles.alphListItem}>{t(title)}</Text>
    );

    const content = (
        <View style={{ marginBottom: 12 }}>
            {type === "records" ? (
                <EntityRecordsTable
                    leading={sectionTitle}
                    columns={columns}
                    records={records}
                />
            ) : (
                <KeyValueTable
                    leading={sectionTitle}
                    rows={rows}
                    titleColumnLabel={titleColumnLabel}
                    detailsColumnLabel={detailsColumnLabel}
                />
            )}
        </View>
    );

    if (breakBefore) {
        return <View break>{content}</View>;
    }

    return content;
};

export default withNamespaces()(ReportSectionBlock);
